var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',_vm._b({},'b-col',_vm.options,false),_vm._l((_vm.children),function(node,index){return _c(node.component,{key:index,tag:"component",attrs:{"options":node.options,"children":node.children}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }